// extracted by mini-css-extract-plugin
export default {"MovieHeader":"title_MovieHeader__nT9Q4"};